import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';

export const useGetPrivacyAndTerms = (): any => {
  const { data, isLoading, send } = useRequest({
    url: '/api/v1/media/documents',
    method: ApiMethodsEnum.Get,
    sendOnStart: false,
  });

  const getPrivacyAndTerms = (type: 'privacyPolicy' | 'termsAndConditions') => {
    send().then((res) => {
      if (res?.data?.[type]?.link) {
        window.open(res?.data?.[type]?.link, '_blank');
      }
    });
  };

  return {
    isLoading,
    getPrivacyAndTerms,
    data,
  };
};
